<template>
  <div>
    <PremiumFeatureBadge
      v-if="showBadge"
      :class="$style.icon"
    />

    <slot
      v-else
      name="else"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import FeatureTrialMixin from 'client/GrowthEngineering/utilities/FeatureTrialsMixin';
import PremiumFeatureBadge from 'components/Badges/PremiumFeatureBadge';

export default {
  name: 'PremiumFeatureFlag',
  components: {
    PremiumFeatureBadge,
  },

  mixins: [
    FeatureTrialMixin,
  ],

  props: {
    feature: {
      type: String,
      default: () => null,
    },
    hideIfTrial: {
      type: Boolean,
      default: () => false,
    },
  },

  computed: {
    ...mapState('SettingsModule', [
      'isCustomer',
    ]),

    showBadge() {
      const planHasFeature = this.planHasFeature(this.feature);
      const hideForTrial = this.hideIfTrial ? this.hasActiveFeatureTrial(this.feature) : false;
      let showBadge = false;

      if (this.feature && !planHasFeature && !hideForTrial && this.isCustomer) {
        showBadge = true;
      }
      return showBadge;
    },

  },
};

</script>

<style scoped module>
.icon {
  display: inline-flex;
}
</style>
